import { ReportFramdPage } from './ReportFramdPage';
export default ReportFramdPage;
